// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"24d6c15e","242":"ec19dd96","453":"4e831c6d","751":"114a4b1d"}[chunkId] + ".chunk.js";
};